import { RISK_REPORTS } from 'src/utils/constants/RiskReports'
import {
  CLIENT_TYPE,
  EMPLOYEE_BENEFIT_POLICY_LIST,
  GROUP_HEALTH_INSURANCE_LIST,
  HEALTH_INSURANCE_LIST,
  HEALTH_PERSONAL_INSURANCE_LIST,
  MOTOR_INSURANCE_LIST,
  MOTOR_PERSONAL_INSURANCE,
  PERSONAL_INSURANCE_LIST,
  POLICY_STATUS_TYPES,
  POLICY_TYPE,
  ROLES,
} from 'src/utils/constants/common'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import formatDate from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'

export const getFullName = (nameList) => {
  const filteredNames = nameList.filter((nameListItem) => nameListItem)
  return filteredNames.join(' ').trim()
}

export const isCorporateLeader = (roles) => {
  return roles.includes(ROLES.CORPORATE_LEADER)
}

export const isCorporateAdmin = (roles) => {
  return roles.includes(ROLES.CORPORATE_ADMIN)
}

export const isCorporateCeo = (roles) => {
  return roles.includes(ROLES.CORPORATE_CEO)
}

export const isCorporatePOC = (roles) => {
  return roles.includes(ROLES.CORPORATE_POC)
}

export const isCorporate = (roles) => {
  return roles.includes(ROLES.CORPORATE)
}

export const getChartData = (data, insuranceType) => {
  const claimsOutstanding = data
    .map((v) => v.claimsOutstanding)
    .reduce(function (a, b) {
      return a + b
    }, 0)
  const claimsPaid = data
    .map((v) => v.claimsPaid)
    .reduce(function (a, b) {
      return a + b
    }, 0)
  const totalClaims = data
    .map((v) => v.totalClaims)
    .reduce(function (a, b) {
      return a + b
    }, 0)
  const totalPremium = data
    .map((v) => v.totalPremium)
    .reduce(function (a, b) {
      return a + b
    }, 0)

  const turnOver = data
    .map((v) => v.turnOver)
    .reduce(function (a, b) {
      return a + b
    }, 0)

  let chartData

  if (insuranceType !== INSURANCE_NAMES.MARINE_INSURANCE) {
    chartData = [totalPremium, totalClaims, claimsPaid, claimsOutstanding]
  } else {
    chartData = [turnOver, totalPremium, totalClaims]
  }
  return chartData.map((a) =>
    a > 0 ? Number((a / RISK_REPORTS.TO_LAKHS).toFixed(2)) : 0
  )
}

export const getAgeChartData = (data) => {
  const chartData = [0, 0, 0, 0, 0, 0]
  Array.isArray(data) &&
    data.forEach((item) => {
      if (item.value && item.group === '18-25') {
        chartData[0] = chartData[0] + item.value
      } else if (item.value && item.group === '26-35') {
        chartData[1] = chartData[1] + item.value
      } else if (item.value && item.group === '36-45') {
        chartData[2] = chartData[2] + item.value
      } else if (item.value && item.group === '46-55') {
        chartData[3] = chartData[3] + item.value
      } else if (item.value && item.group === '56-60') {
        chartData[4] = chartData[4] + item.value
      } else if (item.value && item.group === '60+') {
        chartData[5] = chartData[5] + item.value
      }
    })

  return chartData
}

export const getPolicyStatus = (statusType) => {
  switch (statusType) {
    case POLICY_STATUS_TYPES.active:
      return 'Active'
    case POLICY_STATUS_TYPES.verificationPending:
      return 'Verification Pending'
    case POLICY_STATUS_TYPES.digitalizing:
      return 'Digitalizing'
    case POLICY_STATUS_TYPES.documentRequired:
      return 'Document Required'
    case POLICY_STATUS_TYPES.expired:
      return 'Expired'
    case POLICY_STATUS_TYPES.inactive:
      return 'Inactive'
    case POLICY_STATUS_TYPES.invalidDocument:
      return 'Invalid Document'
    case POLICY_STATUS_TYPES.needMoreInfo:
      return 'Need More Information'
    case POLICY_STATUS_TYPES.renewed:
      return 'Renewed'
    default:
      return ''
  }
}

export const getStatusButtonClass = (statusType) => {
  switch (statusType) {
    case POLICY_STATUS_TYPES.verificationPending:
      return 'verification-status-button'
    case POLICY_STATUS_TYPES.digitalizing:
      return 'digitalizing-status-button'
    default:
      return 'policy-status-button'
  }
}

export const getClientId = (clientId, userInfo) => {
  if (clientId) {
    return clientId
  } else {
    return userInfo.userInfo.userData.clientId === null
      ? userInfo.userName
      : userInfo.userInfo.userData.clientId
  }
}

export const getClientType = (clientType, userInfo) => {
  if (clientType) {
    return clientType
  } else {
    return userInfo.userInfo.userData.policyHolderType
  }
}

export const getClientTypeUrl = (clientType) => {
  if (clientType === CLIENT_TYPE.CORPORATE) {
    return 'corporate'
  }
  return 'individual'
}

export const isPersonalPolicy = (policyType) => {
  return policyType === POLICY_TYPE.PERSONAL
}

export const getQueryParams = (search) => {
  return new URLSearchParams(search)
}

export const formatTableCellValue = (key, value) => {
  if (value) {
    switch (key) {
      case 'pendingFrom':
      case 'dateOfBirth':
      case 'dateOfAdmission':
      case 'dateOfDischarge':
      case 'dateOfLoss':
        return formatDate(value)
      case 'amountClaimed':
      case 'settledClaimAmount':
      case 'outstandingClaimAmount':
      case 'finalApprovedAmount':
        return formatToINR(value)
      default:
        return value ?? '-'
    }
  }
  return '-'
}

export const scrollToTop = () => {
  window.scrollTo(0, 0)
}

export const getUrlLastRoute = () => {
  const urlRouteArray = window.location.href.split('/')
  return urlRouteArray[urlRouteArray.length - 1]
}

export const removeScroll = () => {
  if (typeof window != 'undefined' && window.document) {
    document.body.classList.add('overflow-hidden')
  }
}

export const addScroll = () => {
  if (typeof window != 'undefined' && window.document) {
    document.body.classList.remove('overflow-hidden')
  }
}
export const removeSpaces = (inputText) => {
  if (inputText === '') return ''
  else {
    return inputText.replace(/\s/g, '')
  }
}

export const getAge = (date) => {
  if (date === '') {
    return 0
  }
  const birthDate = new Date(date)
  const birthYear = birthDate.getFullYear()
  const presentDate = new Date()
  const presentYear = presentDate.getFullYear()
  return presentYear - birthYear
}

export const getShortAmount = (value) => {
  let val = Math.abs(value)
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(1) + ' Cr'
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(1) + ' Lacs'
  } else if (val >= 1000) {
    val = Math.round(val / 1000) + ' K'
  }
  return val
}

export const isMotorInsurance = (insuranceType) => {
  return insuranceType === INSURANCE_NAMES.MOTOR_INSURANCE
}

export const isHealthInsurance = (insuranceType) => {
  return HEALTH_INSURANCE_LIST.includes(insuranceType)
}

export const daysCalculator = (date) => {
  const givenDate = new Date(date)
  const currentDate = new Date()

  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24

  // Calculating the time difference between two dates
  const diffInTime = currentDate.getTime() - givenDate.getTime()

  // Calculating the no. of days between two dates
  return Math.round(diffInTime / oneDay)
}

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const getInsuranceTypesList = (insuranceTypesData) => {
  if (insuranceTypesData) {
    return insuranceTypesData.reduce((subtypes, item) => {
      const mainType = JSON.parse(item)
      const subTypes = mainType.SubType ?? [mainType.InsuranceType]
      return subtypes.concat(subTypes)
    }, [])
  } else return []
}

export const getfullName = (nameList) => {
  const filteredNames = nameList.filter((nameListItem) => nameListItem)
  if (filteredNames.length) {
    return filteredNames.join(' ').trim()
  }
  return null
}

export const scrollToComponent = (id) => {
  document
    .getElementById(id)
    .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
}
export const getProviderImage = (policy) => {
  return MOTOR_INSURANCE_LIST.includes(policy.insuranceType)
    ? policy?.productImage
    : policy?.provider?.image
}

export const getThumbNail = (url) => {
  if (url === null) {
    return ''
  }
  const results = url.match('[\\?&]v=([^&#]*)')
  const video = results === null ? url : results[1]

  return 'http://img.youtube.com/vi/' + video + '/0.jpg'
}

export const getFullAddress = (address) => {
  if (!address) {
    return ''
  }

  let fullAddressArray = []
  if (address?.addressLine) {
    fullAddressArray.push(address?.addressLine)
    fullAddressArray.push(address?.landmark || '')
    fullAddressArray.push(address?.pincode || '')
    fullAddressArray.push(address?.city || '')
    fullAddressArray.push(address?.state || '')
  }
  return fullAddressArray?.join(', ')
}

export const hideChatIcon = () => {
  const chatIcon = document.getElementById('chatIconId')
  if (chatIcon) {
    chatIcon.style.visibility = 'hidden'
  }
}

export const showChatIcon = () => {
  const chatIcon = document.getElementById('chatIconId')
  if (chatIcon) {
    chatIcon.style.visibility = 'visible'
  }
}

export const isEBPolicy = (insuranceType) => {
  return EMPLOYEE_BENEFIT_POLICY_LIST?.includes(insuranceType)
}

export const calculatePolicyStartDate = (endDate, duration) => {
  // Convert the end date string to a Date object
  const endDateObj = new Date(endDate)

  // Add the duration in milliseconds (duration * 24 * 60 * 60 * 1000)
  const durationInMilliseconds = duration * 24 * 60 * 60 * 1000
  const startDateObj = new Date(endDateObj.getTime() + durationInMilliseconds)

  const day = String(startDateObj.getDate()).padStart(2, '0')
  const month = String(startDateObj.getMonth() + 1).padStart(2, '0') // Months are zero-based
  const year = startDateObj.getFullYear()

  return `${year}-${month}-${day}`
}

export const calculatePolicyEndDate = (startDate) => {
  const startDateObj = new Date(startDate)
  const policyEndDateObj = new Date(startDateObj)
  policyEndDateObj.setFullYear(startDateObj.getFullYear())
  policyEndDateObj.setDate(policyEndDateObj.getDate() + 1)
  const year = policyEndDateObj.getFullYear()
  const month = String(policyEndDateObj.getMonth() + 1).padStart(2, '0')
  const day = String(policyEndDateObj.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const isGroupHealthInsurance = (insuranceType) => {
  return GROUP_HEALTH_INSURANCE_LIST?.includes(insuranceType)
}

export const isHealthPersonalInsurance = (insuranceType) => {
  return HEALTH_PERSONAL_INSURANCE_LIST?.includes(insuranceType)
}

export const isPersonalInsurance = (insuranceType) => {
  return PERSONAL_INSURANCE_LIST?.includes(insuranceType)
}

export const isMotorPersonalInsurance = (insuranceType) => {
  return MOTOR_PERSONAL_INSURANCE?.includes(insuranceType)
}

export const isCorporateIndividual = (roles) => {
  return roles?.includes(ROLES?.CORPORATE_INDIVIDUAL)
}

export const isRetailIndividual = (roles) => {
  return roles?.includes(ROLES?.RETAIL_INDIVIDUAL)
}
